import { useState, useEffect, useRef, useMemo } from "react";

import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

function LazyImage(props) {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      {...props}
      loading="lazy"
      style={{
        ...props.style,
        opacity: loaded ? 1 : 0,
        transition: "opacity 0.5s ease",
      }}
      onLoad={() => setLoaded(true)}
    />
  );
}

const sections = [
      {
    id: "color",
    title: "analog color",
    photos: [
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img%20%2850%29.jpg", width: 2400, height: 3600, alt: "img (50)" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img%20%2857%29.jpg", width: 3600, height: 2400, alt: "img (57)" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img%20%2855%29.jpg", width: 3600, height: 2400, alt: "img (55)" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img%20%287%29.jpg", width: 3600, height: 2400, alt: "img (7)" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img%20%2820%29.jpg", width: 3600, height: 2400, alt: "img (20)" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/_Bild005_Neg.Nr.6.jpg", width: 3600, height: 2400, alt: "_Bild005 Neg.Nr.6" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/6.jpeg", width: 3600, height: 2400, alt: "6" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/9.jpeg", width: 2400, height: 3600, alt: "9" },    
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/15d.jpeg", width: 2400, height: 3600, alt: "15d" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/54a.jpeg", width: 3600, height: 2400, alt: "54a" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/scn (23).jpg", width: 3600, height: 2400, alt: "scn (23)" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/Image%202%20%283%29.jpg", width: 2400, height: 3600, alt: "Image 2 (3)" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/Untitled%20%2828%29.jpeg", width: 2400, height: 3600, alt: "Untitled (28)" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/66a.jpeg", width: 3600, height: 2400, alt: "66a" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/42b.jpeg", width: 3600, height: 2400, alt: "42b" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/10.jpeg", width: 3600, height: 2400, alt: "10" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/39b.jpeg", width: 2400, height: 3600, alt: "39b" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/36c.jpeg", width: 2400, height: 3600, alt: "36c" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/48a.jpeg", width: 2400, height: 3600, alt: "48a" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/57c.jpeg", width: 3600, height: 2400, alt: "57c" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/31d.jpeg", width: 3600, height: 2400, alt: "31d" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/32e.jpeg", width: 2400, height: 3600, alt: "32e" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/33b.jpeg", width: 3600, height: 2400, alt: "33b" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/67a.jpeg", width: 2400, height: 3600, alt: "67a" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/69a.jpeg", width: 2400, height: 3600, alt: "69a" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/scn%20%2811%29.jpg", width: 2400, height: 3600, alt: "scn (11)" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img_new013.jpeg", width: 2400, height: 3600, alt: "img_new013" },

        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/_Bild001_Neg.Nr.2.jpg", width: 2400, height: 3600, alt: "_Bild001 Neg.Nr.2" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/Bild012_Neg.Nr.13A.jpg", width: 2400, height: 3600, alt: "Bild012 Neg.Nr.13A" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/3.jpeg", width: 3600, height: 2400, alt: "3" },

        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/45a.jpeg", width: 2400, height: 3600, alt: "45a" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/6.jpg", width: 2400, height: 3600, alt: "6 (jpg)" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/68a.jpeg", width: 3600, height: 2400, alt: "68a" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/8.jpeg", width: 2400, height: 3600, alt: "8" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img%20%2832%29.jpg", width: 3600, height: 2400, alt: "img (32)" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img%20%2846%29.jpg", width: 3600, height: 2400, alt: "img (46)" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img%20%2847%29.jpg", width: 3600, height: 2400, alt: "img (47)" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img005.jpeg", width: 3600, height: 2400, alt: "img005" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img018.jpeg", width: 2400, height: 3600, alt: "img018" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/img_new011.jpeg", width: 2400, height: 3600, alt: "img_new011" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/scn%20%2822%29.jpg", width: 3600, height: 2400, alt: "scn (22)" },
        // { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Color/30c.jpeg", width: 2400, height: 3600, alt: "30c" },
    ],
  },
  {
    id: "black-and-white",
    title: "analog black and white",
    photos: [
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/1.jpeg", width: 2400, height: 3600 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/9.jpeg", width: 2400, height: 3600 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/11.jpeg", width: 3600, height: 2400 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/14.jpeg", width: 2400, height: 3600 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/22.jpeg", width: 3600, height: 2400 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/bw0 (12).jpeg", width: 2400, height: 3600 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/8.jpeg", width: 2400, height: 3600 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/bw (11).jpeg", width: 2400, height: 3600 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/5.jpeg", width: 2400, height: 3600 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/25.jpeg", width: 2400, height: 3600 },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/BW/bw0 (17).jpeg", width: 7000, height: 2000 },
    ],
  },
    {
    id: "thermal-print",
    title: "thermal print",
    photos: [
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/1.jpg", width: 3600, height: 2400, alt: "img005" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/2.jpg", width: 3600, height: 2400, alt: "img005" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/3.jpg", width: 3600, height: 2400, alt: "img005" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/4.jpg", width: 3600, height: 2400, alt: "img005" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/5.jpg", width: 3600, height: 2400, alt: "img005" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/6.jpg", width: 3600, height: 2400, alt: "img005" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/7.jpg", width: 3600, height: 2400, alt: "img005" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/8.jpg", width: 3600, height: 2400, alt: "img005" },
        { src: "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/9.jpg", width: 3600, height: 2400, alt: "img005" },
    ],
  },
];

export default function Photography() {
  const [index, setIndex] = useState(-1);
  const [activeId, setActiveId] = useState(sections[0]?.id ?? "");
  const observerRef = useRef(null);

  // Flatten all section photos into a single slides array for the Lightbox.
  // Also build a cumulative offset so we can map per-section click index
  // to the global flat index.
  const { allPhotos, offsets } = useMemo(() => {
    const all = [];
    const off = [];
    let cumulative = 0;
    for (const section of sections) {
      off.push(cumulative);
      all.push(...section.photos);
      cumulative += section.photos.length;
    }
    return { allPhotos: all, offsets: off };
  }, []);

  // IntersectionObserver to track which section is currently in view.
  useEffect(() => {
    const headings = sections.map((s) => document.getElementById(s.id)).filter(Boolean);
    if (headings.length === 0) return;

    const handleIntersect = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveId(entry.target.id);
        }
      });
    };

    observerRef.current = new IntersectionObserver(handleIntersect, {
      rootMargin: "-20% 0% -35% 0px",
    });

    headings.forEach((el) => observerRef.current.observe(el));

    return () => observerRef.current?.disconnect();
  }, []);

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="photography-layout">
      {/* Sidebar navigation */}
      <aside className="photography-sidebar">
        <nav className="photography-sidebar-nav">
          <ul className="article-toc-list">
            {sections.map((s) => (
              <li
                key={s.id}
                className={`article-toc-item${activeId === s.id ? " is-active" : ""}`}
              >
                <button
                  type="button"
                  className="article-toc-link"
                  onClick={() => scrollToId(s.id)}
                >
                  {s.title}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {/* Photo content */}
      <div className="photography-content">
        {sections.map((section, sectionIdx) => (
          <section key={section.id} id={section.id}>
            <h2 className="photography-section-title">{section.title}</h2>
            <RowsPhotoAlbum
              photos={section.photos}
              targetRowHeight={500}
              onClick={({ index: photoIdx }) =>
                setIndex(offsets[sectionIdx] + photoIdx)
              }
              render={{
                image: (props) => <LazyImage key={props.src} {...props} />,
              }}
            />
          </section>
        ))}
      </div>

      {/* Single shared lightbox over all photos */}
      <Lightbox
        slides={allPhotos}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        plugins={[Fullscreen, Zoom]}
      />
    </div>
  );
}
